import * as React from 'react';

import './Radio.css';

export interface IRadioProps {
  checked: boolean;
  onChange(): void;
  children: JSX.Element | JSX.Element[];
}

export default (props: IRadioProps) => {
  const { checked, onChange } = props;
  return (
    <div className="radio-label" onClick={onChange}>
      <div className={`radio ${checked ? 'checked' : ''}`}>
        <div className="marker"></div>
      </div>
      {props.children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Radio/Radio.tsx